document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.brochurePrijzen__pageContent')) {
    const toggleOptions = document.querySelectorAll('.form-options li');
    const formDigitaal = document.querySelector('.formBrochure--digitaal');
    const formPost = document.querySelector('.formBrochure--post');

    toggleOptions.forEach((option) => {
      option.addEventListener('click', () => {
        // Verwijder actieve class van alle toggles
        toggleOptions.forEach((opt) => opt.classList.remove('-active'));
        // Voeg actieve class toe aan de geselecteerde toggle
        option.classList.add('-active');

        // Toon/verberg formulieren en werk URL bij
        if (option.id === 'email') {
          formDigitaal.classList.add('-active');
          formPost.classList.remove('-active');
          updateUrlParameter('form', 'email');
        } else if (option.id === 'post') {
          formDigitaal.classList.remove('-active');
          formPost.classList.add('-active');
          updateUrlParameter('form', 'post');
        }
      });
    });

    // Functie om URL-parameter bij te werken
    function updateUrlParameter(key, value) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set(key, value);
      window.history.pushState({}, '', `?${urlParams.toString()}`);
    }

    // Controleer URL-parameters bij het laden van de pagina
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('form')) {
      if (urlParams.get('form') === 'post') {
        document.getElementById('post').click();
      } else {
        document.getElementById('email').click();
      }
    } else {
      // Standaard: toon digitaal formulier en zet toggle email actief
      document.getElementById('email').classList.add('-active');
      formDigitaal.classList.add('-active');
      formPost.classList.remove('-active');
    }
  }
});
